module.exports = __webpack_public_path__ + "img/016.cf0549de.png";